import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import AccountService from "../../Services/AccountService";
import { useAuth } from "../../Utils/Auth";
import { useNavigate } from "react-router-dom";
import {
  Table,
  ProgressBar,
  Card,
  Button,
  InputGroup,
  FormControl,
  Alert,
} from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import NewPagination from "./NewPagination";
// import NewPagination from "../NewPagination";

const InnerIntroducer = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [client, SetClient] = useState([]);
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const pageLimit = 10;
  const startIndex = Math.min((page - 1) * pageLimit + 1);
  const endIndex = Math.min(page * pageLimit, totalData);

  const { id } = useParams();
console.log("page", page)
  const selectPageHandler = (selectedPage) => {
    console.log(selectedPage);
    setPage(selectedPage);
  };

  useEffect(() => {
    AccountService.introducerUsersingleProfile( id,
    page,
    pageLimit,
    q,
    auth.user)
      .then((res) => {
        SetClient(res.data.data);
        setTotalData(res?.data?.pagination?.totalItems);
        setTotalPage(res?.data?.pagination?.totalPages);
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  }, [auth.user, id , q , page]);

  // const filteredUsers = client.filter((affiliate) => {
  //   const fullName = affiliate.userName.toLowerCase();
  //   return fullName.includes(q.toLowerCase());
  // });

  const handelShowPercentage = (e, id) => {
    console.log("console", id);
    navigate(`/transactiondetails/${id}`);
  };

  return (
    <div className="container pt-4">
      <InputGroup className="mb-3">
        <FormControl
          placeholder="Search User By Username"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </InputGroup>
      <h5 className="text-center mb-3">List of Users</h5>
      {client && client.length > 0 ? (
        <Table striped bordered hover>
          <thead>
            <tr align="center">
              <th>User Name</th>
              <th>Name</th>
              <th>Percentage</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {client?.map((user) => (
              <tr key={user._id} align="center">
                <td>{user.userName}</td>
                <td>
                  {user.firstName} {user.lastName}
                </td>
                <td>
                  <div
                    className="progress"
                    style={{ height: "30px", backgroundColor: "#e9ecef" }}
                  >
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${(user.introducerPercentage || 0) * 10}%`,
                        background: `linear-gradient(90deg, #00c6ff, #0072ff)`,
                        color: "white",
                        fontWeight: "bold",
                        transition: "width 0.5s ease",
                      }}
                      aria-valuenow={(user.introducerPercentage || 0) * 10}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {user.introducerPercentage || 0}%
                    </div>
                  </div>
                </td>

                <td>
                  <Button
                    onClick={(e) => handelShowPercentage(e, user.userId)}
                    style={{
                      backgroundColor: "#17a2b8",
                      borderColor: "#17a2b8",
                      padding: "10px 20px",
                      borderRadius: "30px",
                      color: "white",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    Show Transactions <FaArrowRight />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Alert variant="warning" className="d-flex justify-content-center">No Network Found</Alert>
      )}

      {client.length > 0 && (
        <NewPagination
          currentPage={page}
          totalPages={totalPage}
          handlePageChange={selectPageHandler}
          startIndex={startIndex}
          endIndex={endIndex}
          totalData={totalData}
        />
      )}
    </div>
  );
};

export default InnerIntroducer;
